<template>
    <section class='main-content'>
     
     <section class="wrap-content">
         
         
         <div class="body">
             <header>
                 <AppButton style="color: var(--icon);" v-bind:visibility="true"
                     left_icon="fa-regular fa-circle-xmark fa-xl" emitType="close"
                     @click="close" :width=20 :height=20 :padding="'0px'" />
             </header>
 
             <form >
                 <section class="top-input">
                     <span>
                         <label for="dataInicio">Início:</label>
                         <input style="background-color: var(--label); color: var(--text);" v-model="task_data.dataInicio"  class="pl-1 pr-1" type="date" id="dataInicio" name="dataInicio" required>
                     </span>
                     <span>
                         <label for="dataPrazo">Prazo:</label>
                         <input style="background-color: var(--label); color: var(--text);" v-model="task_data.dataPrazo" class="pl-1 pr-1" type="date" id="dataPrazo" name="dataPrazo" required>
                     </span>
                     <span>
                         <label for="tarefa">Tarefa:</label>
                         <input style="background-color: var(--label); color: var(--text);" v-model="task_data.tarefa" class="pl-2 w-[15em]" type="text" id="tarefa" name="tarefaField" placeholder="ex.: Instalação na..." required>
                     </span>
                 </section>
                 <section class="text flex column ">
                     <label for="descricao">Observações:</label>
                     <textarea style="background-color: var(--label); color: var(--text);" v-model="task_data.observacao" class="w-[30em] resize-none min-h-[10em] text-black p-1 rounded bg-[#fff]" placeholder="Observações da tarefa..." id="descricao" name="descricao" required>{{ '' }}</textarea>
                 </section>
             </form>
 
         </div>
         
         <p class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] min-w-[9.8em] ">Tipo: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ task_data.tipo?.nome ?? 'N/A' }} </span>
             <button  @click="openDialog('tptarefa')" class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p>
         <p class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] min-w-[9.8em] ">Objeto: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ 'N/A' }} </span>
             <button class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p>
         <p class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] min-w-[9.8em] ">Ação: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ task_data.acao?.nome ??  'N/A' }} </span>
             <button @click="openDialog('tpacao')" class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p>
         <p v-if="task_type != 'individual'" class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] min-w-[9.8em] ">Tipo Utilizador: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ task_data.tputilizador?.nome ??  'N/A' }} </span>
             <button @click="openDialog('tputilizador')" class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p>
         <p v-else class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] min-w-[9.8em] ">Utilizador: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ task_data.utilizador?.user ??  'N/A' }} </span>
             <button @click="openDialog('utilizador')" class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p>
         <!-- <p class="flex h-5 align-center justify-between w-fit min-w-[30%]">
             <span class="mt-1 text-[.7em] ">Tarefa {{ task_type }} para: </span> 
             <span class=" ml-1 flex align-center text-[var(--icon)]">{{ 'N/A' }} </span>
             <span v-for="i in 5" class="flex ml-2 bg-[#c2c2c2] rounded p-[.1em]" >
                 <span class="">
                     <span>
                         <span>User 00{{ i }}</span>
                     </span>
                     <span class="text-red-800">
                         X
                     </span>
                 </span>
             </span>
             <button class="ml-1em ml-6 text-[var(--icon)] flex align-center h-6 mt-1">
                 <Icon class="edit-icon" icon="lucide:edit" />
             </button>
         </p> -->
         
         <div class="footer pt-2">
             <section class="left flex gap-2">
                 <button v-for="item in propsData.buttons" class="p-1 text-[.7em] rounded-md bg-[var(--icon)] text-['#006698'] "
                  @click="dinamicButton(item)"
                  :style="item == task_type ? 'background-color: var(--bg-pop-up); color: var(--icon);' : ''"
                  >{{ item }}
                 </button>
             </section>
             <section class="right flex gap-2">
                 <button class="p-1 text-[.7em] rounded-md bg-[red]"    @click="close" >Cancelar</button>
                 <button class="p-1 text-[.7em] rounded-md bg-[#006698]" @click="confirmDialog" >Confirmar</button>
                 
             </section>
         </div>
     
     </section>
 
     <Dialog v-if="dialogStatus" @close="dialogStatus = false" @returnData="setSelectResult" :propsData="dialogProps" />
 
    </section>
 </template>
   
 <script>
  
     import AppButton from '@/components/updated/button.vue';
     import Dialog from '@/components/dialog/dinamicDialog.vue';
 
     export default { 
  
         components: {   
             AppButton,
             Dialog,
         }, 
 
         props: {
 
             propsData: {
                 type: Object,
                 default: () => {
                     return {
                         entity: ['equipamento'],
                         buttons: ['individual', 'grupo'],
                         sideBar: true,
                         multi: false,
                         specialQuery: null,
                         // currentEntity: 'equipamento',
                         
                     }
                 }
             },
         },
 
        data(){
            return{ 
                 task_type: 'individual',              
 
                 task_data: {
                     dataInicio: '01-01-2021',
                     dataPrazo: '',
                     tarefa: '',
                     observacao: '',
                     tipo: {},
                     tputilizador: {},
                     utilizador: {},
                     objeto: {},
                     tarefaPara: {},
 
                     
 
 
                 },
 
                 dialogStatus: false,
                 currentType: '',
                 dialogProps: {
                     entity: ["tputilizador", 'tptarefa', 'tpacao'],
                     sideBar: true,
                     queryParams: {
                         armazem: "custom=1",
                         viatura: "custom=1",
                         tpa: "custom=1",
                         tputilizador: "custom=1",
                         utilizador: "custom_2=1",
                     },
                     askMessage:'Deseja copiar as permissões deste tipo de utilizador',
                     specialQuery:{
                         chefe: "utilizador/s/chefe/",
                         responsavel: "utilizador/s/responsavel/",
                     }
                 },
            } 
        }, 
        methods: {
         
         
             setSelectResult(result) {
                 console.log("RESPOSTA:", result[[this.currentType]]);
 
                 if (this.currentType == "tptarefa") {
                     this.task_data.tipo = result[[this.currentType]];
                     return;
                 }
 
                 if (this.currentType == "tpacao") {
                     this.task_data.acao = result[[this.currentType]];
                     return;
                 }
 
                 else{
                     this.task_data[[this.currentType]] = result[[this.currentType]];
                 }
                 
             },
 
 
 
             openDialog(entity){
                 this.dialogProps.entity[0] = entity;
                 this.currentType = entity;
                 this.dialogStatus = true;
             },
 
 
 
             getCurrentDate(){
                 const date = new Date();
                 return `${date.getMonth()}/${date.getDate()}/${date.getFullYear()}`;
             },
         
             close(){
                 this.$emit('closeCreateTask');
             },
 
             confirmDialog(){
                 // console.log('Task Data: ');
 
 
                 let finalData = {
                     tarefa: this.task_data.tarefa,
                     dataInicial: this.task_data.dataInicio ?? null,
                     dataPrazo: this.task_data.dataPrazo ?? null,
                     observacao: this.task_data.observacao,
                     tpTarefa_id: this.task_data.tipo.id ?? 0,
                     tpUtilizador_id: this.task_data.tputilizador.id ?? 0,
                     utilizador_id: this.task_data.utilizador.id ?? 0,
                     objeto_id:  0,
                     tpAcao_id: this.task_data.acao.id ?? 0,                   
                 }
 
                 
                 this.$emit('returnData', finalData);
                 // alert('Dados enviados com sucesso!');
             }, 
             
             dinamicButton(item){
 
                 const validTypes = ['individual', 'grupo'];
 
                 if(this.task_type == item || !validTypes.includes(item)){
                     return;
                 }
 
                 this.task_type = item;
             }
        }, 
 
        created(){
             // this.task_data.dataInicio = this.getCurrentDate();
        } 
 
    }
 
 </script>
  
 <style scoped>
 
    .main-content{ 
         padding: 3em;
         padding-left: 5em;
         padding-top: 6em;
         background-color: var(--bg-pop-up);
         border-radius: 1em;
         /*width: 100%; */
         width: 100vw;
         height: 100dvh;
         position: fixed;
         display: flex;
         justify-content: center;
         top: 0;
         left: 0;
 
         z-index: 10000;
     } 
     
     .wrap-content{ 
         position: relative;
         padding: 1em;
         background-color: transparent;
         border-radius: .2em;
         background-color: var(--fundoForm);
         color: var(--label);
         width: fit-content;
         height: fit-content;  
         min-height: 20em;
         min-width: 50em;
 
         display: flex;
         flex-direction: column;
         justify-content: space-between;
 
 
         position: absolute;
         top: 3em;
         left: 50%;
         transform: translateX(-50%);
         /*transform: translate(-50%, -50%);
         cursor: move; */
     }
 
     .wrap-content header{ 
         display: flex;
         justify-content: flex-end;
         padding: .3em;
         padding-bottom: .5em;
     }
 
     .body{ 
         display: flex;
         flex-direction: column;
         justify-content: flex-start;
         
         height: 100%;
         flex: .8;
        
         gap: .2em;
     }
 
     .footer{ 
         display: flex;
         justify-content: space-between;
         gap: 1em;
     }
 
 
     form{
         display: flex;
         flex-direction: column;
         gap: 1em;
     }
 
 
     form .top-input{
         display: flex;
         justify-content: flex-start;
         gap: 1em;
         height: 100%;
     }
 
     form .top-input span{
         display: flex;
         gap: .5em;
     }
 
 
     form input{
         color: #000000cc;
         border-radius: .3em;
     }
 
     form input[type="date"]{
         width: 8em;
     }
     
 </style> 